import{m as n}from"./chunk-HBP5N4FR.js";n();var o=(t,g=4)=>`${t.substring(0,Math.floor(t.length/g))}...${t.substring(t.length-Math.ceil(t.length/g))}`;export{o as a};
//# sourceMappingURL=chunk-7F3MKQYJ.js.map
